<template>
  <div class="lds-ring size-10">
    <div />
    <div />
    <div />
    <div />
  </div>
</template>

<script>
  export default {
    name: 'overlay-loader',
    props: {
      rounded: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style scoped>
  .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 28px;
    height: 28px;
    margin: 4px;
    border: 3px solid #fff;
    border-color: #fff transparent transparent transparent;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  }

  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }

  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }

  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }

  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
